export const fontSize = 16;

export const px = (value: number) => `${value / fontSize}rem`;
